import React from 'react'

export default function CampaignReport() {
  return (
    <div>
      <h1>Campaign Report</h1>
    </div>
  )
}
